/*
 * @Descripttion: 订单关怀首页
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */

import React, {useState, useEffect} from "react";
import {Tab} from '@alifd/next';
import { event, store } from '@ice/stark-data';
import LzNotice from '@/components/common/LzNotice';
import utils from '@/common/utils';
import LineBox from "./components/lineBox";
import TaskList from "./components/taskList";
import SummaryResult from "./components/summaryResult";
import styles from './index.module.scss';

const Notice = <div>
  <div>1. 【全链路订单关怀】中每个节点显示的数据，均统计的是符合该节点订单状态的历史订单数量累计；并不代表需要关怀的实际订单数量</div>
  <div>2. 【物流关怀】阶段，需要订阅抖音官方电子面单，方可使用；若未订阅抖音官方电子面单则由第三方支持（需单独收费）</div>
</div>

const OrderCares = () => {
  const [currentTabKey, setCurrentTabKey] = useState(1);
  const init = (): void => {
    /** 设置Header面包屑 */
    utils.setBreadcrumb({
      name: '订单关怀', // 一级页面名称
      url: '/web/order/care', // 一级页面url
      children: {
        name: '关怀首页', // 二级页面名称
        url: '/web/order/care', // 二级页面url
      },
    });

    // 将当前key 传入父组件
    event.emit('currentTab', '');
  };

  useEffect(() => {
    init();
  }, []);

  return <div className={styles['order-cares-constainer']}>
    <div style={{height: 50}}>
      <LzNotice cotent={Notice} />
    </div>

    <div>
      <LineBox />
    </div>

    <div className={styles['task-list']}>
      <Tab>
        <Tab.Item title="任务列表" key={1}>
          <TaskList />
        </Tab.Item>
        <Tab.Item title="效果数据汇总" key={2}>
          <SummaryResult />
        </Tab.Item>
      </Tab>
    </div>
  </div>;
};

export default OrderCares;
